import { AccountPage } from "../components/pages/account/AccountPage";
import { AuthPage } from "../components/pages/auth/AuthPage";
import { VerifyPage } from "../components/pages/auth/VerifyPage";
import { OtpLoginPage } from "../components/pages/auth/OtpLoginPage";
import { OtpResetPage } from "../components/pages/auth/OtpResetPage";
import { OtpSignupVerifyPage } from "../components/pages/auth/OtpSignupVerifyPage";
import { DevicesPage } from "../components/pages/devices/DevicesPage";
import { DeviceOrdersPage } from "../components/pages/devices/DeviceOrdersPage";
import { HomePage } from "../components/pages/home/HomePage";
import { InvestPage } from "../components/pages/invest/InvestPage";
import { LoansPage } from "../components/pages/loans/LoansPage";
import { NotificationsPage } from "../components/pages/notifications/NotificationsPage";
import { InstitutionDetailPage } from "../components/pages/institutions/InstitutionDetailPage";
import { OnboardPage } from "../components/pages/onboard/OnboardPage";
import { WalletPage } from "../components/pages/wallet/WalletPage";
import { ListViewHandler } from "../handlers/ListViewHandler";
import { AdvisorPage } from "../components/pages/advisor/AdvisorPage";
import { HelpCenterPage } from "../components/pages/help/HelpCenterPage";
import { LearnPage } from "../components/pages/learn/LearnPage";

import { MyDepositsPage } from "../components/pages/deposits/MyDepositsPage";
import { MyWithdrawalsPage } from "../components/pages/withdrawals/MyWithdrawalsPage";
import { MyManualRepaymentsPage } from "../components/pages/manual-repayments/MyManualRepaymentsPage";
import { PaymentMethodsPage } from "../components/pages/account/PaymentMethodsPage";
import { TermsOfServicePage } from "../components/pages/legal/TermsOfServicePage";
import { AutoInvestPage } from "../components/pages/autoinvest/AutoInvestPage";
import { NotificationPreferencesPage } from "../components/pages/settings/NotificationPreferencesPage";


import {
  ACCOUNT,
  AUTOINVEST,
  DEVICES,
  DEVICE_ORDERS,
  INVEST,
  LOANS,
  NOTIFICATIONS,
  ONBOARD,
  WALLET,
} from "./constants";

export const guestRoutes = [
  {
    path: "auth/:id",
    component: <AuthPage />,
  },
  {
    path: "verify-email/",
    component: <VerifyPage />,
  },
  {
    path: "auth/otp-login",
    component: <OtpLoginPage />,
  },
  {
    path: "auth/reset-password",
    component: <OtpResetPage />,
  },
  {
    path: "auth/verify-phone",
    component: <OtpSignupVerifyPage />,
  },
  {
    path: "legal/terms",
    component: <TermsOfServicePage />,
  },
];

export const standardRoutes = [
  {
    path: "/",
    component: <HomePage />,
  },
  {
    path: WALLET,
    component: <WalletPage />,
  },
  {
    path: LOANS,
    component: <LoansPage />,
  },
  {
    path: INVEST,
    component: <InvestPage />,
  },
  {
    path: ONBOARD,
    component: <OnboardPage />,
  },
  {
    path: ACCOUNT,
    component: <AccountPage />,
  },
  // Device financing
  {
    path: DEVICES,
    component: <DevicesPage />,
  },
  {
    path: DEVICE_ORDERS,
    component: <DeviceOrdersPage />,
  },
  // Notifications
  {
    path: NOTIFICATIONS,
    component: <NotificationsPage />,
  },
  // Notification preferences (per-channel × per-category toggles)
  {
    path: "settings/notifications",
    component: <NotificationPreferencesPage />,
  },
  {
    path: "list/:source",
    component: <ListViewHandler />,
  },
  // Institution detail
  {
    path: "institutions/:id",
    component: <InstitutionDetailPage />,
  },
  {
    path: "list/:source",
    component: <ListViewHandler />,
  },

  // Help & Learn
  {
    path: "help",
    component: <HelpCenterPage />,
  },
  {
    path: "learn",
    component: <LearnPage />,
  },

  // Financial advisor
  {
    path: "advisor",
    component: <AdvisorPage />,
  },
  {
    path: "list/:source",
    component: <ListViewHandler />,
  },

  // ── Phase 6: Manual Operations ──
  {
    path: "payment-methods",
    component: <PaymentMethodsPage />,
  },

  // Legal
  {
    path: "legal/terms",
    component: <TermsOfServicePage />,
  },

  // AutoInvest (managed investment)
  {
    path: AUTOINVEST,
    component: <AutoInvestPage />,
  },
];